import React from "react"

import IGroup from "./models/group"
import { IncidentListItem, ArchivedIncidentItem } from "./utils/form-field-mapping"
import Inspection from "./models/inspection"
import { Form as FormStructure } from "./models/new/forms.types"
import Issue from "./models/issue"

interface IGroupContext {
  groups: undefined | IGroup[]
  setGroups: React.Dispatch<React.SetStateAction<undefined | IGroup[]>>
}

interface IIncidentContext {
  incidents: undefined | IncidentListItem[]
  setIncidents: React.Dispatch<React.SetStateAction<undefined | IncidentListItem[]>>

  archivedIncidents: undefined | ArchivedIncidentItem[]
  setArchivedIncidents: React.Dispatch<React.SetStateAction<undefined | ArchivedIncidentItem[]>>
}

interface IInspectionContext {
  inspections: undefined | Inspection[]
  setInspections: React.Dispatch<React.SetStateAction<undefined | Inspection[]>>

  archivedInspections: undefined | Inspection[]
  setArchivedInspections: React.Dispatch<React.SetStateAction<undefined | Inspection[]>>

  inspectionForms: undefined | FormStructure[]
  setInspectionForms: React.Dispatch<React.SetStateAction<undefined | FormStructure[]>>
}

interface IIssueContext {
  issues: undefined | Issue[]
  setIssues: React.Dispatch<React.SetStateAction<undefined | Issue[]>>

  archivedIssues: undefined | Issue[]
  setArchivedIssues: React.Dispatch<React.SetStateAction<undefined | Issue[]>>

  issueForms: undefined | FormStructure[]
  setIssueForms: React.Dispatch<React.SetStateAction<undefined | FormStructure[]>>
}

// @ts-ignore
export const GroupContext = React.createContext<IGroupContext>()

// @ts-ignore
export const IncidentContext = React.createContext<IIncidentContext>()

// @ts-ignore
export const InspectionContext = React.createContext<IInspectionContext>()

// @ts-ignore
export const IssueContext = React.createContext<IIssueContext>()
